import type { ColDef, ValueFormatterParams } from 'ag-grid-community';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseGoods } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 > 반출 재고 조회 테이블
 */
const getStockReleaseRegisterInventoryColumnDefs = () => {
  const columnDefs: ColDef<TypeStockReleaseGoods>[] = [
    {
      headerName: '',
      valueFormatter: () => '',
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 44,
    },
    {
      field: 'barcode',
      headerName: '상품 바코드',
      width: 140,
    },
    {
      field: 'skuCode',
      headerName: 'SKU코드',
      width: 140,
    },
    {
      field: 'clusterCodeObject.name',
      headerName: '반출 출발지 센터',
      width: 116,
    },
    {
      field: 'temperatureTypeCodeObject.name',
      headerName: '보관 유형',
      width: 76,
    },
    {
      field: 'skuName',
      headerName: '상품명',
      width: 240,
    },
    {
      field: 'totalQuantity',
      headerName: '전체 재고',
      width: 76,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['totalQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'availableQuantity',
      headerName: '가용 재고',
      width: 76,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['availableQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'allocationQuantity',
      headerName: '작업중 재고',
      width: 100,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['allocationQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'holdingQuantity',
      headerName: '보류 재고',
      width: 90,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['holdingQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'defectiveQuantity',
      headerName: '불용 재고',
      width: 90,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseGoods, TypeStockReleaseGoods['defectiveQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
  ];

  return { columnDefs };
};

export default getStockReleaseRegisterInventoryColumnDefs;
